// import router from 'vue-router'
import Vue from 'vue'


const actions = {

}

export default actions

